module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightFilter2-c8ff65ce981c3768c41dbfcb2108ed9d.jpg";